import { USER_ACCOUNT_STATUS } from "@/types/enum";

export const canResetPassword = (hasPassword?: boolean, accountStatus?: string): boolean => {
  if (!hasPassword) return false;
  if (accountStatus === USER_ACCOUNT_STATUS.INVITATION_SENT || accountStatus === USER_ACCOUNT_STATUS.PASSWORD_RESET) return false;
  return true;
};

export const canResendInvitation = (accountStatus?: string): boolean => accountStatus === USER_ACCOUNT_STATUS.INVITATION_SENT;
